import Header from './components/Header';
import Hero from './components/Hero';
import IndexSection from './components/IndexSection';
import UpdatesSection from './components/UpdatesSection';
import CarouselSection from './components/CarouselSection';
import MediaSection from './components/MediaSection';
import AboutSection from './components/AboutSection';
import ContactSection from './components/ContactSection';
import FaqSection from './components/FaqSection';
import RankingSection from './components/RankingSection';
import FeaturesSection from './components/FeaturesSection';
import CardsSection from './components/CardsSection';
import TopicsSection from './components/TopicsSection';
import AppSection from './components/AppSection';
import CommentsSection from './components/CommentsSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50 text-foreground-200 font-body">
      <Header />
      <main>
        <Hero />
        <IndexSection />
        <UpdatesSection />
        <CarouselSection />
        <MediaSection />
        <AboutSection />
        <ContactSection />
        <FaqSection />
        <RankingSection />
        <FeaturesSection />
        <CardsSection />
        <TopicsSection />
        <AppSection />
        <CommentsSection />
      </main>
      <Footer />
    </div>
  );
}